export default "__VITE_ASSET__DyOY$C3A__"